import React, { useContext, useEffect, useState } from "react"
import { ConfigContext } from "../../../contexts/ConfigContext"
import useWindowSize from "../../../hooks/useWindowSize"
import NavContent from "./NavContent"
import navigation from "../../../menu-items"
import humps from "humps"
import { USER_ROLES } from "../../../routes/routesState"
import { RoutePaths } from "../../../routes/RoutePaths"
import { useChatContext } from "../../../assets/js/features/chat/state/context/ChatContext"
import AllTextState from "../../../assets/shared/state/AllTextState"
import { APIROUTES } from "../../../../src/routes/APIRoutes"
import { getData } from "../../../assets/shared/api/ApiCalls";
import { GetUserRole } from "../../../utils/userUtil";
import { Role } from "../../../models/enum";
import { getToken } from "../../../assets/js/features/token/TokenEncryption"
import { axiosPrivate } from "../../../api/axios"
import { getUserLocalization, setTenentType } from "../../../assets/js/app/state/appSessionStorage"

const Navigation = () => {
  const configContext = useContext(ConfigContext)
  const { state } = useChatContext()
  const {
    layout,
    layoutType,
    navFixedLayout,
    collapseMenu,
    rtlLayout,
    boxLayout,
    subLayout,
    headerFixedLayout
  } = configContext.state
  const windowSize = useWindowSize()
  const [claimsEnabled, setClaimsEnabled] = useState(false);
  const [casesEnabled, setCasesEnabled] = useState(false);

  const [menuTitles, setMenuTitles] = useState({
    claimManagement: AllTextState.claimManagement // default title
  })


  const [clubTitles, setClubTitles] = useState({
    clubManagement: AllTextState.clubManagement // default title
  })
  const [userDetails, setUserDetails] = useState(null);
  const [localization, setLocalization] = useState(null);

  const fetchMenuTitles = async () => {
    try {
      const serviceToken = getToken();
      const response = await axiosPrivate.get(APIROUTES.USER.GET_USER_DETAILS, {
        headers: {
          Authorization: `Bearer ${serviceToken}`,
        },
      });
      const userDetails = response.data;
      setUserDetails(userDetails);
      setTenentType(userDetails.tenantType);
    } catch (error) {
      console.error('Error fetching user details:', error);
      // Handle error appropriately
    }
  };

  const fetchLocalisation = async () => {
    try {
      const response = await axiosPrivate.get("rest/get_user_localization")
      //code here to add localization key value data
      setLocalization(response.data)
      return response.data
    } catch (err) {
      console.log(err)
      const status = err?.response?.status
      return { status: status }
    }
  }

  // Fetch the titles from the API when the component mounts
  useEffect(() => {
    const role = GetUserRole();

    const fetchData = async () => {
      await fetchMenuTitles()
    }

    if (role !== Role.SUPER_ADMIN)
    {
      fetchData()
    }
  }, [])

  useEffect(() => {
    if (!userDetails) {
      setMenuTitles({
        claimManagement: "Management"
      });
      return;
    }

    const { tenant, tenantType, userInfo } = userDetails;

    if (tenantType) {

      if (tenantType.casesEnabled) setCasesEnabled(true);
      if (tenantType.claimsEnabled) setClaimsEnabled(true);
      let type = tenantType.claimsEnabled ? "Claims" : "Case";
      const localization = getUserLocalization();
      if (localization && localization.clubManagement) {
        setClubTitles({ clubManagement: localization.clubManagement });
      } else {
        setClubTitles({ clubManagement: AllTextState.clubManagement });
      }

      return;
    }

    setMenuTitles({
      claimManagement: "Management"
    });
  }, [userDetails])

  // useEffect(() => {
  //   if (localization && localization.clubManagement) {
  //     setClubTitles({ clubManagement: localization.clubManagement });
  //   } else {
  //     setClubTitles({ clubManagement: AllTextState.clubManagement });
  //   }
  // }, [localization]);


  const scroll = () => {
    if (navFixedLayout && headerFixedLayout === false) {
      const main = document.querySelector(".pcoded-navbar")
      const el = document.querySelector(".pcoded-navbar.menupos-fixed")
      const scrollPosition = window.pageYOffset
      if (scrollPosition > 60) {
        el.style.position = "fixed"
        el.style.transition = "none"
        el.style.marginTop = "0"
      } else {
        main.style.position = "absolute"
        main.style.marginTop = "56px"
      }
    } else {
      document.querySelector(".pcoded-navbar").removeAttribute("style")
    }
  }

  let navClass = ["pcoded-navbar", layoutType]

  if (layout === "horizontal") {
    navClass = [...navClass, "theme-horizontal"]
  } else {
    if (navFixedLayout) {
      navClass = [...navClass, "menupos-fixed"]
    }

    if (navFixedLayout && !headerFixedLayout) {
      window.addEventListener("scroll", scroll, true)
      window.scrollTo(0, 0)
    } else {
      window.removeEventListener("scroll", scroll, false)
    }
  }

  if (windowSize.width < 992 && collapseMenu) {
    navClass = [...navClass, "mob-open"]
  } else if (collapseMenu) {
    navClass = [...navClass, "navbar-collapsed"]
  }

  if (layoutType === "dark") {
    document.body.classList.add("gradient-able-dark")
  } else {
    document.body.classList.remove("gradient-able-dark")
  }

  if (rtlLayout) {
    document.body.classList.add("gradient-able-rtl")
  } else {
    document.body.classList.remove("gradient-able-rtl")
  }

  if (boxLayout) {
    document.body.classList.add("container")
    document.body.classList.add("box-layout")
  } else {
    document.body.classList.remove("container")
    document.body.classList.remove("box-layout")
  }

  let navBarClass = ["navbar-wrapper"]
  if (layout === "horizontal" && subLayout === "horizontal-2") {
    navBarClass = [...navBarClass, "container"]
  }

  const getNavigation = () => {
    const userPermission = JSON.parse(sessionStorage.getItem("userPermission"))
    const role = userPermission
      ? userPermission.currentRole
      : configContext.state.userPermission.currentRole

    if (!role) return []

    const updateClaimManagementTitle = (menu) => {
      if (!claimsEnabled) {
        menu = menu.filter(m => m.id !== 'Claim Management');
      }
      if (!casesEnabled) {
        menu = menu.filter(m => m.id !== 'Case Management');
      }

    
      const temp = menu.map(item =>
        item.id === 'Club Management' || item.id === 'Organisation Management'
          ? { ...item, title: clubTitles.clubManagement, id: clubTitles.clubManagement } // Update title dynamically
          : item
      );
      return temp;
    }

    switch (humps.camelize(role)) {
      case "all":
        return navigation.all
      case "superAdmin":
        return navigation.superAdmin
      case "tenantAdmin":
        return updateClaimManagementTitle(navigation.tenantAdmin)
      case "claimManager":
        return updateClaimManagementTitle(navigation.claimManager)
      case "claimant":
        return updateClaimManagementTitle(navigation.claimant)
      case "orgAdmin":
        return updateClaimManagementTitle(navigation.orgAdmin)
      case "rehabManager":
      case USER_ROLES.EMPLOYER:
        return updateClaimManagementTitle(navigation.rehabManager)
      default:
        return []
    }
  }

  const getChatCount = (conversionList, groupList) => {
    let unreadCount
    const unreadCountChat = conversionList?.reduce((count, item) => {
      if (item.unreadCount > 0) {
        count += item.unreadCount
      }
      return count
    }, 0)

    const chatGroupList = Object.keys(groupList).map((key) => groupList[key])
    const unreadCountGroup = chatGroupList?.reduce((count, item) => {
      if (item.unreadCount > 0) {
        count += item.unreadCount
      }
      return count
    }, 0)

    unreadCount = unreadCountChat + unreadCountGroup
    return unreadCount > 9 ? "9+" : unreadCount
  }

  const checkForNotification = (routes) => {
    const updatedRoute = routes.map((route) => {
      if (route.url === RoutePaths.APPOINTMENTS)
        return {
          ...route,
          badge: {
            title: state.newAppointmentCount > 9 ? "9+" : state.newAppointmentCount,
            type: "badge-info"
          }
        }
      if (route.url === RoutePaths.CHATS)
        return {
          ...route,
          badge: {
            title: getChatCount(state.conversionList, state.chatGroupList),
            type: "badge-info"
          }
        }
      return route
    })
    return updatedRoute
  }

  let navContent = (
    <div className={navBarClass.join(" ")}>
      <NavContent navigation={checkForNotification(getNavigation())}/>
    </div>
  )
  if (windowSize.width < 992) {
    navContent = (
      <div className="navbar-wrapper">
        <NavContent navigation={checkForNotification(getNavigation())}/>
      </div>
    )
  }

  return (
    <React.Fragment>
      <nav className={navClass.join(" ")}>{navContent}</nav>
    </React.Fragment>
  )
}

export default Navigation
